// Конфигурация для подключения к серверу
// Автоматическое определение URL на основе текущего окружения

function getServerConfig() {
  const { protocol, hostname, port } = window.location;
  
  // Если заходим через обычный домен (через Nginx proxy)
  // или через HTTPS - используем относительные пути
  if (port === '' || port === '80' || port === '443') {
    return {
      apiUrl: '/api',
      socketUrl: `${protocol}//${hostname}`
    };
  }
  
  // Если заходим напрямую на порт 3000 (локально) - используем прямое подключение
  if (port === '3000') {
    return {
      apiUrl: `${protocol}//${hostname}:3000/api`,
      socketUrl: `${protocol}//${hostname}:3000`
    };
  }
  
  // Fallback - относительные пути
  return {
    apiUrl: '/api',
    socketUrl: `${protocol}//${hostname}`
  };
}

const SERVER_CONFIG = getServerConfig();

export { getServerConfig };
export default SERVER_CONFIG;
